import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLibuvComponent } from './simple-icons-libuv.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLibuvComponent ],
    exports:      [ SimpleIconsLibuvComponent ],
    bootstrap:    []
})
export class SimpleIconsLibuvModule {}
